import { useRootStore } from '~/stores/root'
import { getErrorStatus } from '~/utils/http/api-error'

// Nuxt2 expressed this as a `@HandleCartFailure()` method decorator on every cart
// service call. That decorator used the legacy `(target, key, PropertyDescriptor)`
// signature, which only compiles under `experimentalDecorators: true` — set in the
// Nuxt2 tsconfig, absent from the Nuxt4 generated tsconfigs (which also set
// `useDefineForClassFields: true`). Under TS5 defaults `@Foo()` is parsed as a
// stage-3 decorator, whose method form is `(value, context)`, so the Nuxt2
// implementation cannot be re-enabled as written. The guard is therefore a plain
// helper the service calls from one shared request wrapper — same behaviour, no
// compiler flag. AB#63254.

/**
 * A cart call that fails with a server error or a missing cart leaves the cart in an
 * unknown state, so the user gets the blocking failure dialog rather than a silently
 * stale page. Client errors (400/409/422) are the caller's to handle and must not
 * raise it.
 */
export const isCartFailureStatus = (statusCode: number | undefined): boolean =>
  statusCode !== undefined && (statusCode >= 500 || statusCode === 404)

/**
 * Raises the cart failure dialog when the error warrants it. Never swallows the
 * error — callers rethrow so `$api()`'s non-2xx rejection still reaches the caller.
 */
export const flagCartFailure = (error: unknown): void => {
  if (isCartFailureStatus(getErrorStatus(error))) {
    useRootStore().cartFailureDialog = true
  }
}
